import React, { useEffect, useState } from "react";

/**
 * Lightweight typewriter that types `text` once at mount.
 * Renders a blinking caret while typing and after completion.
 */
export const Typewriter = ({
  text,
  speed = 55,
  startDelay = 350,
  className = "",
  testId,
}) => {
  const [shown, setShown] = useState("");

  useEffect(() => {
    let i = 0;
    let timer;
    const start = setTimeout(() => {
      timer = setInterval(() => {
        i += 1;
        setShown(text.slice(0, i));
        if (i >= text.length) clearInterval(timer);
      }, speed);
    }, startDelay);
    return () => {
      clearTimeout(start);
      if (timer) clearInterval(timer);
    };
  }, [text, speed, startDelay]);

  return (
    <span
      data-testid={testId}
      className={`cursor-blink ${className}`}
      aria-label={text}
    >
      {shown}
    </span>
  );
};

export default Typewriter;
